const SDK_VERSION = '7.52.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
